<template>
  <div id="app">
    <header class="app-header text-right fixed-top" ref="app-header">
      <a href="/" class="app-header__volver">
        &laquo; Volver <span class="d-none d-sm-inline">a la portada</span>
      </a>
      <a href="/">
        <img  :src="idDiario == 12 ? require(`@/assets/image/${idDiario}.png`) : require(`@/assets/image/${idDiario}.svg`)" alt="" />
      </a>
    </header>
    <section-1 />
    <section-3 />
    <section-4 />
    <section-2 />
    <footer class="app-footer">
      <p><b>Unidad de Investigación y Datos</b></p>
      <p class="app-footer__text-staff">Francisco Ahumada (Análisis de datos) • Carla Escobedo (Diseño) • Freddy Palencia (Desarrollo)</p>
    </footer>
  </div>
</template>
<script>
import { auth } from '@/services'
export default {
  name: 'home',
  data() {
    return {
      idDiario: window.app.idDiario,
    }
  },

  mounted() {
    auth.init(this);
  }
}
</script>
<style lang="scss">
  @import './src/styles/vendor.scss';
  @import './src/styles/main.scss';
  @import url('https://fonts.googleapis.com/css?family=Noticia+Text:400,400i,700,700i&display=swap');

body {
  overflow-x: hidden;
}

.section__texto {
  &--md{
    font-size: 1.5rem;
  }
}

.section__text-fuente {
  font-size: 0.8rem;
  color:#fff;
  font-weight: bold;

  @include media-breakpoint-up(md) {
    font-size: 1rem;
  }
}

.section__numeros {
  font-size: 4.2rem;
  color:#fff;
  &--md {
    font-size: 2rem;
  }
}

.resaltar-texto {
  color: #fff;
  padding-left: 0.4rem;
  box-shadow: 6px 0px 0px 0 #c1272d;
  background-color: #c1272d;
  line-height: 1.5;
  margin-right: 0.5rem;
}

.isselected {
  color: #ffffff;
  background-color: #000;
  transition: all .3s ease-in-out;
}

.bg-red-transparent {
  background-color: rgba(193, 39, 45, 0.8);
}

.app-footer {
  background-color: #204c5f;
  color: #fff;
  padding: 1rem;
  text-align: right;

  &__text-staff {
    font-size: 0.7rem;

    @include media-breakpoint-up(md) { font-size: 1rem; }
  }


  p {
    margin-bottom: 0.3rem;

    b {
      color: #fff;
    }
  }
}
</style>
